import React from 'react';
import { Button } from 'reactstrap';
import { useBillingActions, useFlowActions } from '../../../../context';
import { ActionButtonGroup, DowngradeBillingDetailsFooter } from '../../../shared';

/**
 * Component that displays the downgrade offer for users who select "tooExpensive" as their reason
 * Offers a $15/month discount plan as an alternative to cancellation
 */
const CostDowngradeOffer = () => {
  // Get actions from context
  const { switchPlan } = useBillingActions();
  const { cancelAnyway } = useFlowActions();
  return (
    <div className="cost-downgrade-offer-content">
      <div className="mb-4">
        <h5 className="mb-3">Thanks for letting us know that the cost of WLC is a challenge for you.</h5>
        <p className="mb-3">
          We get it. And we'd love to keep supporting your health journey, without adding financial strain. That's why
          we've created a more affordable option, just for times like this.
        </p>
        <p className="mb-3">
          Instead of canceling, you can switch to our <strong>$15/month discount plan</strong>. You can keep all your
          WHOLE Life Club benefits (recipes, lessons, and community) at a lighter monthly cost.
        </p>
        <p className="mb-4">It's the same membership, just at a price that fits where you are today.</p>

        <ActionButtonGroup
          primaryAction={{
            text: 'Switch My Plan to $15/month',
            onClick: switchPlan,
            color: 'primary',
            className: 'mb-3'
          }}
          secondaryAction={{
            text: 'Cancel Anyway',
            onClick: cancelAnyway
          }}
          layout="vertical"
        />

        <DowngradeBillingDetailsFooter className="pause-details mb-3" />
      </div>
    </div>
  );
};

export default CostDowngradeOffer;
